import { useCallback } from 'react';

import { useVideoPlatform, useVideoPlatformCallback } from '../../../hooks/useVideoPlatform';

/**
 * Use this to check whether to show the rejoin flow and reconnecting indicators
 * for Zoom. Twilio users should not see reconnection indicators or a manual way
 * to rejoin while in a session (that's behavior that's [exclusive to
 * Zoom](https://devforum.zoom.us/t/how-to-handle-internet-disconnection-properly/65018)).
 */
export function useIsRejoinEnabled() {
  const videoPlatform = useVideoPlatform();
  const getVideoPlatform = useVideoPlatformCallback();

  const checkRejoinIsEnabled = useCallback(() => getVideoPlatform() === 'zoom', [getVideoPlatform]);

  return [videoPlatform === 'zoom', checkRejoinIsEnabled] as const;
}
